module.exports = __webpack_public_path__ + "img/slide2-content.79c10246.png";